<template>
    <div class="wrapper">
        <h2 style="text-align: center;margin-bottom: 20px;">文字作品线上发布授权协议</h2>

        <h4>第一条【重要提示】</h4>
        <p>请您（以下亦称“发布者”）在使用喜马拉雅平台A+有声化平台（以下亦称“有声化平台”）提供的内容发布平台技术服务时，以及点击同意本协议之前，仔细阅读本协议之全部条款，并确认您已完全理解本协议之规定（未成年人应在法定监护人陪同下审阅）。尤其是权利义务条款、收益分配及支付条款、免责条款、法律适用及争议解决条款等。如您对协议有任何疑问，请立即停止使用本平台，并可向喜马拉雅平台客服咨询。</p>

        <h4>第二条【协议的接受与变更】</h4>
        <p>2.1 在您充分阅读并且理解本协议，并勾选本协议前选项框“同意”，将视为您签署了本协议，表明您自愿接受本协议全部条款的约束，本协议将构成您与上海证大喜马拉雅网络科技有限公司及其关联公司（以下简称“喜马拉雅公司”），以及其经营的包括但不限于喜马拉雅网、“喜马拉雅fm”移动客户端（亦称为“主站”）、“喜马拉雅fm”车载客户端、喜马拉雅开放API及SDK平台等平台、喜马拉雅“轻学堂”以及日后喜马拉雅公司新开发或经营的其他平台（以下简称为“喜马拉雅平台”或“平台”）之间具有约束力的法律文件。</p>
        <p>2.2 由于互联网技术发展迅速，喜马拉雅公司保留在维护您权益的前提下修改本协议的权利，协议修订后，喜马拉雅公司将在相关页面公布修订后的协议，修订后的协议一经公布即有效的代替原协议。如果您选择在本协议修改后继续发布文字作品及改编后的音频作品的，则视为您已接受本协议的修改；如果您不同意本协议的修改，请立即停止发布新的文字作品，并联系喜马拉雅客服下架您已发布的文字作品。</p>
        <p>2.3 您与喜马拉雅公司签署的本协议所列明的条款，并不能完全涵盖您与喜马拉雅公司所有的权利和义务。喜马拉雅公司公布其他声明、规则等均视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>

        <h4>第三条【合作内容】</h4>
        <p>3.1 文字作品有声化任务的发布及主播招募</p>
        <p>3.1.1 您点击同意本协议后，并在有声化平台发布文字作品有声化任务时，请务必完整发布文字作品，并准确填写任务信息、任务要求（如音频时长、期数等）、招募人数、发布方式、主播可得报酬等信息。</p>
        <p>3.1.2 您在发布任务时可自行选择免费专辑或付费专辑两种发布方式中的一种。根据您选择的发布方式，采取不同的收益分成模式：若您选择的是免费专辑，则在改编音频发布至喜马拉雅平台后产生的广告收益，在扣除各项成本后，您可分得50%作为报酬，喜马拉雅公司也将收取余下的50%作为平台技术服务费用。若您选择的是付费专辑，则在改编音频发布至喜马拉雅平台后通过喜马拉雅平台及喜马拉雅公司授权的第三方分销渠道销售后产生的收益，在扣除各项成本（包括但不限于渠道成本、支付成本、促销成本等费用）后，您可分得50%作为报酬，喜马拉雅公司也将收取余下的50%作为平台技术服务费用。具体结算详见本协议第五条。</p>
        <p>3.1.3 按您在发布任务时所设定的“一口价”金额，您需向喜马拉雅公司支付履约保证金，保证金的金额与您向主播承诺的报酬中的金额一致（具体保证金额详见发布任务的页面）；否则，您将无法成功发布任务。（示例：若您发布的任务中主播报酬为一口价80元/小时，您发布的任务为20小时的，则您需在发布任务的同时向喜马拉雅公司支付人民币1600元作为履约保证。）若您发布的任务最终未成功的，保证金将在【30】个工作日内悉数退还。</p>
        <p>3.1.4 您知悉，任务一旦发布将视为您向喜马拉雅主播发起邀约邀请。喜马拉雅主播根据任务页的要求进行竞标，您需在海选规定的时间内从竞标的主播中做出选择，一旦您选中主播，即视为您与该主播之间建立音频委托制作协议。若您未选中主播或未在规定时间内选择主播的话，则视为本次任务发布未成功。一旦选中主播后，您承诺将按所发布的任务信息履行包括但不限于主播报酬、发布方式等义务约定。</p>
        <p>3.1.5 您在有声化平台上传文字作品并发布任务的同时，将视为您同意喜马拉雅公司及喜马拉雅平台行使您发布的文字作品的信息网络传播权，喜马拉雅公司有权在其运营的各平台展示并宣传推广您发布的文字作品，以提供给喜马拉雅主播选择录制任务。同时将视为您将所发布的文字作品的有声改编权在您文字作品发布期间在全球范围内授权给喜马拉雅主播进行有声改编，。在您根据本协议及喜马拉雅平台规则向通过有声化平台招募的喜马拉雅主播支付相应费用后，有声改编后的音频作品著作权归您所有。</p>
        <p>3.2 改编音频的发布</p>
        <p>3.2.1 若您在发布任务时选择的音频发布方式为免费专辑的，则由主播直接在喜马拉雅平台发布已录制完成的音频内容以供喜马拉雅用户免费收听或下载。若您在发布任务时选择的音频发布方式为付费专辑的，主播在录制完成并交付您后，您需在【7】天内将主播录制完的音频发布至喜马拉雅平台以供喜马拉雅用户付费收听或付费下载。</p>
        <p>3.2.2 您在喜马拉雅平台发布改编音频的同时，将视为您授权喜马拉雅公司及喜马拉雅平台行使您发布的音频作品的复制权、发行权、广播权、信息网络传播权、汇编权、改编权等完整的著作权利及相应转授权，并向喜马拉雅平台以及喜马拉雅公司再授权的第三方分销渠道用户提供付费及免费收听或付费及免费下载服务。喜马拉雅公司将根据不同平台定位、作品内容、客户需求、作品形式等等因素将改编后的音频作品或作品片段或单期通过选择或者编排汇集成的汇编作品进行使用。在主站发布改编的音频期间，喜马拉雅公司有权自行决定就发布的音频以及相关汇编作品是否纳入平台会员体系通过平台、分销渠道或分发平台使用、推广、销售、传播及运营。期间产生收益的，喜马拉雅公司将继续按本协议的约定与您结算收益。</p>

        <h4>第四条【作品发布及审核】</h4>
        <p>就您上传并发布的文字及音频作品，喜马拉雅公司有权进行审核与验收。如您上传的作品不符合喜马拉雅公司要求或本协议约定的，应在接到通知后1个工作日内进行改正；若您未在规定时间内改正或拒不改正的，则您的行为视为根本违约，喜马拉雅公司有权删除或屏蔽您上传的不符合要求的音频作品，若因此给喜马拉雅公司造成任何损失的，喜马拉雅公司有权要求您赔偿包括直接损失和间接损失在内的全部损失。</p>

        <h4>第五条 【收益分配及支付】</h4>
        <p>5.1您的分成收益与结算</p>
        <p>您将与喜马拉雅公司按照下述比例对付费型音频专辑所获得的净收益进行分成，净收益为通过您发布的付费型音频专辑获得的总收入扣除成本（包括但不限于渠道成本、支付成本、促销成本等费用）。其中，当付费型音频专辑在各平台单独售卖的，所产生的实际销售额计入总收入，您就此可获得的分成比例为50%，喜马拉雅FM可获得的分成比例为(100-50)%，您同意按如下公式计算您的净收入，即您可获得的单卖净收入为：（单卖总收入-成本）*50%。当音频是纳入平台会员体系进行售卖的，您的收益以您通过喜马拉雅公司主播收益中心后台直接查询的数据为准，该等会员收益是喜马拉雅公司根据音频在喜马拉雅各平台的当月有效播放、当月各平台的会员总收入、节目类型（有声书类型）、节目时长和50%的分成比例等变量计算而成。具体结算规则可参见喜马拉雅平台公示的政策。</p>
        <p>5.2 您同意，喜马拉雅公司与您将按如下规则进行结算：</p>
        <p>您每一个自然月的可得分成，喜马拉雅公司将于该月结束后的第二个自然月内与您结算（举例而言，您于2017年1月的分成收入，自2017年3月起可以提现）。如有平台暂时无法实现线上对账结算的，喜马拉雅公司将与您线下进行对账结算。</p>
        <p>5.3 喜马拉雅公司按上述规则将分成费用统一结算至您拥有的喜马拉雅平台账户。您可从您的喜马拉雅平台账户进行提现，且每个自然月提现一次，提现的金额为截止至上一个自然月最后一日的全部费用，您需将账户中的所有金额一次性全部提现。如您还加入了喜马拉雅平台其他创收项目的，包括但不限于打赏创收项目、广告创收项目等，您也需将全部收益一次性全部提现。</p>
        <p>5.4 提现账户：喜马拉雅公司将分成费用支付至您的支付宝账户，支付宝账户姓名/名称必须与您预留的真实姓名/名称信息相一致，否则一切损失由您承担。</p>
        <p>5.5 如果您是自然人，根据《中华人民共和国个人所得税法》等相关法律法规的规定，喜马拉雅公司将为您代扣代缴相关税费，喜马拉雅公司将按照上述约定将扣缴相关税费后的分成费支付至您账户。</p>
        <p>5.6 如果您是机构或组织，喜马拉雅公司将分成费统一显示在您在喜马拉雅平台账户，您通过喜马拉雅平台账户进行提现操作后，按照喜马拉雅平台页面的提示开具符合法律及喜马拉雅公司要求的发票并邮寄给喜马拉雅公司。喜马拉雅公司在收到您开具的发票后10个工作日内，将分成费用支付至您的支付宝账户。</p>
        <p>5.7 为扩大付费型音频专辑的知名度，提高音频销量，实现双方的共赢，喜马拉雅平台有权不定期的开展优惠活动，包括但不限于通过第三方平台分销、众筹付费音频，向用户发放优惠券、抵扣券、全站折扣等形式，您同意与喜马拉雅以5:5的比例承担因优惠活动而产生的成本。以iOS端举例而言，用户购买了售价为198.00喜点的专辑，并使用了10.00喜点的优惠券，则此时您实际所获收益为=（198-10）*（1-31.4%）*50%。</p>
        <p>5.8 就付费专辑，在您点击“同意”本协议时，视为您确认并同意加入“喜马拉雅7天无忧退款计划”：若购买者符合《喜马拉雅7天无忧退款政策》中的退款条件且申请无忧退款的，喜马拉雅公司有权直接向购买者退款，且该笔款项将不计入与您结算的总收入内；若购买者未达到《喜马拉雅7天无忧退款政策》中的退款条件的，7天到期后该笔交易款将按本协议约定与您进行结算。具体政策内容以喜马拉雅公司最终发布的《喜马拉雅7天无忧退款政策》为准。</p>

        <h4>第六条 【发布者的权利与义务】</h4>
        <p>6.1 您在将文字作品及改编后的音频作品发布时承诺并保证，对于发布至喜马拉雅各平台的文字作品及改编后的音频作品，均符合包括但不限于《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国反不正当竞争法》、《中华人民共和国侵权责任法》、《中华人民共和国广告法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》及《信息网络传播权保护条例》等有关法律、法规、规章的规定。且符合社会公序良俗，并不侵犯喜马拉雅公司或任何第三方主体的合法权益，也不存在任何权利纠纷。</p>
        <p>6.2 您在发布文字作品及改编后的音频作品时承诺并保证，您在喜马拉雅平台发布上传的文字、图片、音频或其他内容拥有相应合法的权利。这些文字、图片、音频或其他内容，不侵犯任何第三方的肖像权、名誉权、著作权、商标权等任何权利；不违反您与任何第三方所签订的任何对您自己有约束力的法律文件的规定；</p>
        <p>6.3 您在发布文字作品及改编后的音频作品时承诺并保证，您拥有授权给喜马拉雅公司按照本协议约定的方式使用授权文字作品及改编后音频作品的权利；喜马拉雅公司按照本协议约定的方式使用授权文字作品及其改编后的音频作品无需再另行征得任何第三人的同意；除收益分成外，喜马拉雅公司无需向您及/或任何第三方支付任何费用。</p>
        <p>6.4 禁止发布者从事以下行为：</p>
        <p>6.4.1 涉及危害国家安全、泄露国家秘密的；侵犯国家社会集体的和公民的合法权益的；制作、复制、发行或传播带有煽动抗拒、破坏宪法和法律、行政法规实施的，煽动颠覆国家政权，推翻社会主义制度的，煽动分裂国家、破坏国家统一的，煽动民族仇恨、民族歧视，破坏民族团结的，捏造或者歪曲事实，散布谣言，扰乱社会秩序的，宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的，公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的，损害国家机关信誉的，其他违反宪法和法律行政法规的内容。</p>
        <p>6.4.2 冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的。</p>
        <p>6.4.3 伪造标题或以其他方式操控识别资料，使人误认为该内容为喜马拉雅公司所传送的。</p>
        <p>6.4.4 将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送。</p>
        <p>6.4.5 以技术方式攻击或破坏或改变喜马拉雅平台的部分或全部、或干扰其运行；以非法方式获取或使用喜马拉雅平台的任何软件、代码或其他技术或商业信息；禁止发布者对喜马拉雅平台运行的任何程序进行反向工程、反向编译、反向汇编或改写</p>
        <p>6.4.6 未经许可使用喜马拉雅平台的网站名称、公司名称、商标、商业标识、网页版式或内容、或其他由喜马拉雅公司或喜马拉雅平台享有知识产权或权利的信息或资料；将喜马拉雅平台以任何形式作为从事各种非法活动的场所、平台或媒介。除了开展本协议之付费创收项目之必要，未经喜马拉雅公司的书面授权或许可，发布者不得另行以喜马拉雅公司的名义从事任何商业活动，也不得以任何形式将喜马拉雅平台作为从事商业活动的场所、平台或媒介。</p>
        <p>6.4.7 除了开展本协议之付费创收项目之必要，未经喜马拉雅公司书面许可、另行签署协议或另行指定可供发布者使用的特定商业服务外，发布者不得另行以商业目的使用喜马拉雅平台；不对喜马拉雅平台的任何部分或全部进行商业性质利用、复制、拷贝、出售、调查、广告。</p>
        <p>6.4.8 未经喜马拉雅公司书面许可、另行签署协议或另行指定可供发布者使用的特定商业服务外，发布者不得通过喜马拉雅平台发布有关任意第三方的任何广告宣传内容。</p>
        <p>6.5 您同意并承诺，将按照本协议的约定按时按量发布文字作品及改编后的音频内容供喜马拉雅用户收听及下载；在发布作品前，您必须先行确认音频的正确性、完整性、合法性及不违反本协议之约定。依据文字作品改编后的音频一经发布，您不得自行删除，且已付费购买音频内容的用户可永久获得并收听该音频内容；若遇到重大问题必须删除的，您必须自问题发现之日起一天内书面告知喜马拉雅公司，并于收到喜马拉雅公司的书面确认后方可自行删除，或者由喜马拉雅公司作删除处理。若您违反本条的约定，给喜马拉雅公司或喜马拉雅用户造成任何损失的，您同意赔偿任何损失方所遭受的包括直接损失和间接损失在内的全部损失。</p>
        <p>6.6 发布者就其所上传的内容承担全部法律责任。因发布者违反法律规定或本协议规定造成违约或侵犯第三方合法权益的，由发布者自行解决。如果给喜马拉雅公司造成损失的，喜马拉雅公司有权向发布者追偿其因此所遭受的全部损失、包括直接损失、间接损失、预期利益损失等一切损失。</p>
        <p>6.7 介于依据文字作品改编成付费音频后涉及消费者权益，您承诺并保证，将按您在创建专辑时发布的付费音频相关信息（包括但不限于总期数、时长、发布频率、音频内容等）执行。若您违反前述约定的，喜马拉雅公司有权要求您退还已向您支付的全部费用，且不与您继续结算分成；此外，若因此造成喜马拉雅公司或付费音频购买者任何损失的，您应向损失方赔偿全部损失，包括但不限于诉讼费、律师费、公证费、罚金、赔偿金等。</p>
        <p>6.8 您承诺，您在喜马拉雅平台所发布的内容（不限于音频、文字、图片等形式），不带有推广除喜马拉雅平台以外的任何其他平台，包括您的自媒体平台等内容。如喜马拉雅公司发现上述情形，您应在喜马拉雅公司告知您的时间内进行修改，否则喜马拉雅公司有权下架不符合要求的文字或音频内容，若因此造成的任何损失，由您自行承担。</p>
        <p>6.9 如您发现有第三方侵犯授权的文字作品及改编后的付费音频作品之合法权利的，您应该采取积极的措施，与喜马拉雅互相配合，向侵犯方提起诉讼或进行一切行动以保证双方合法权益不受损害。</p>
        <p>6.10 若您违反协议约定或违反您向主播的承诺的，您应自行处理全部纠纷并承担全部责任；若喜马拉雅公司先行赔付的，喜马拉雅公司有权从您支付的保证金中先行支付，若仍不足的，喜马拉雅公司有权向您追偿；此外，若因此给喜马拉雅公司造成任何损失的，您应赔偿全部损失，包括但不限于诉讼费、律师费、公证费、罚金、赔偿金等。</p>

        <h4>第七条【喜马拉雅公司的权利与义务】</h4>
        <p>7.1 喜马拉雅公司承诺并保证，将按照本协议约定的方式使用您授权的文字作品及改编后的音频作品。</p>
        <p>7.2 喜马拉雅公司有权通过喜马拉雅网（www.ximalaya.com）、“喜马拉雅FM”移动客户端、喜马拉雅车载客户端及喜马拉雅开放API/SDK平台等由其运营的各平台展示您授权的文字作品用于有声改编，且使用依据文字作品改编后的音频作品，并向喜马拉雅用户提供收听、下载等服务。此外，您确认并同意喜马拉雅公司通过第三方分销平台分销改编后的音频作品，购买者通过分销渠道购买后可在喜马拉雅网（www.ximalaya.com）、“喜马拉雅FM”移动客户端、喜马拉雅车载客户端及喜马拉雅开放API/SDK平台、喜马拉雅“轻学堂”平台以及日后喜马拉雅公司新开发或经营的其他平台以及第三方分销或分发渠道等喜马拉雅各平台收听或下载音频内容。喜马拉雅公司承诺并保证，通过第三方分销渠道所获得的净收益也将与您按本协议第五条的约定进行分成。</p>
        <p>7.3 喜马拉雅公司有权随时检查您所上传发布的内容，如果发现您上传的内容不符合前述规定的，喜马拉雅公司有权删除或重新编辑或修改您所上传的内容；其中，对于侵犯他人享有著作权利的发布者，喜马拉雅公司有权不经事先通知终止向您提供付费创收服务，并且查封您的账号三个月。但是，对于您通过喜马拉雅平台发布的内容，喜马拉雅公司不保证其合法性、正当性、准确性或完整性。在任何情况下，喜马拉雅公司均不对任何内容承担任何责任，包括但不限于由于任何内容而导致直接或间接损失。您应自行承担因此产生的一切法律后果；若因此给喜马拉雅公司造成任何损失的，喜马拉雅公司有权向您追偿。</p>
        <p>7.4 喜马拉雅平台将尽可能保存您上传的音频或其他内容，但不承诺将为您保存您上传的内容，您应自行就前述内容进行备份。</p>
        <p>7.5 在本协议合作期限内，喜马拉雅公司将向您提供喜马拉雅网（www.ximalaya.com）、“喜马拉雅FM”移动客户端等平台上的推广资源，并以喜马拉雅公司认为适当的方式，包括但不限于适用于文字、图片、声音、影像等形式宣传和推荐您及您发布的文字作品及改编后的音频作品。</p>
        <p>7.6 如有第三方侵犯授权的文字作品及改编后的付费音频作品之合法权利的，喜马拉雅有权采取积极的措施，与您互相配合，向侵犯方提起诉讼或进行一切行动以保证双方合法权益不受损害。</p>

        <h4>第八条 【免责说明】</h4>
        <p>8.1 因不可抗力，包括但不限于地震、台风、火灾、水灾、战争、罢工、暴动、黑客攻击、电信部门技术管制、移动运营商平台故障、移动运营商运营策略改变、政府行政部门行政管制，或任何其它自然或人为造成的灾难等而不能履行本协议的，双方无需承担违约责任。但不可抗力发生方应在10个工作日之内以传真、电挂、邮件等方式将发生的不可抗力事故通知另一方。若不可抗力事故持续15天以上时，双方应通过友好协商尽快解决协议后续问题。如果因不可抗力导致的违约、迟延履行和不能履行自不可抗力事件首次发生之日起超过90日的，未受不可抗力事件影响的一方应有权书面通知受影响的一方单方终止本协议。</p>
        <p>8.2 基于互联网的特殊性，喜马拉雅平台也不担保服务不会中断，对服务的及时性、安全性不作担保，不承担非因喜马拉雅平台导致的责任。喜马拉雅公司力图使您能对本网站进行安全访问和发布音频及其他方式的使用，但喜马拉雅平台不保证本网站或服务器是不含病毒或其它潜在有害因素的；因此您应使用业界公认的软件查杀任何自喜马拉雅平台下载文件中的病毒。</p>
        <p>8.3 您上传的声音、文字、专辑等内容，仅代表您个人观点，并不表示本网站赞同您的观点或证实您的描述，本网站不承担您上传的内容引发的任何法律责任。喜马拉雅公司有权删除喜马拉雅平台内各类不符合法律或协议规定的内容，而保留不通知您的权利。</p>
        <p>8.4 所有发给发布者的通告，喜马拉雅都将通过正式的页面公告或站内信或电子邮件或客服电话或手机短信或常规的信件送达。任何非经喜马拉雅平台正规渠道获得的活动或信息，喜马拉雅平台不承担法律责任。</p>
        <p>8.5 无论在何种情况下，对于已购买付费型音频的消费者，喜马拉雅平台将永久提供收听及下载服务，且无需承担任何法律责任。</p>

        <h4>第九条 【协议的终止】</h4>
        <p>9.1 任意一方出现破产、清算等致使本协议目的不能实现的情况时，对方有权终止本协议，并不承担任何责任。但双方应友好协商决定善后事宜。</p>
        <p>9.2 介于本合作涉及第三人即喜马拉雅用户的付费利益，未获喜马拉雅公司的书面许可，您不得擅自终止本协议。</p>
        <p>9.3 无论因何原因导致本协议终止，都不能免除协议任何一方在协议终止前已发生或应承担的义务，也不能排除任何一方继续行使权利并按照本协议或法律规定请求违约方赔偿的权利。</p>

        <h4>第十条【法律适用、管辖和其他】</h4>
        <p>10.1 本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。与本协议相关的一切争议、权利主张或其他事项，均适用中华人民共和国法律。</p>
        <p>10.2 您与喜马拉雅公司及其经营的喜马拉雅平台发生的一切争议，应友好协商，如协商不成的，应提交上海市浦东新区人民法院管辖。</p>
        <p>10.3 喜马拉雅平台可能不时发布针对文字作品及其改编后的音频的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请您及时关注并阅读相关协议。</p>
        <p>10.4 本协议任意一条被视为废止、无效或不可执行，该条款应视为可分的且不影响本协议其他条款的法律效力。</p>

        <span class="tips">【审慎提醒】如您点击“同意”，则本协议将立即生效，并构成你和上海证大喜马拉雅网络科技有限公司及其经营的喜马拉雅平台之间有约束力的法律文件。
        <br>请您再次确认你已全部阅读并充分理解上述协议。</span>
        <div class="buttons">
            <el-button type="primary" @click.native="agree">{{ $t('word.agree') }}</el-button>
            <el-button @click.native="cancel">{{ $t('word.cancel') }}</el-button>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        components: {

        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
          agree () {
            this.$emit('agreementResult', true);
          },
          cancel () {
            this.$emit('agreementResult', false);
          }
        }
    }

</script>
<style lang="sass" scoped>
    .wrapper {
        padding: 20px;
        padding-top: 0;
    }
    .tips {

    }
    p {
        font-size: 12px;
        text-indent: 2em;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// ReleaseProtocol.vue?05df1d84